/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  ClaimReviewRequest,
  ErrorResponse,
  HTTPValidationError,
  MileageClaimCalculationCreate,
  MileageClaimCalculationRead,
  MileageClaimCreate,
  MileageClaimRead,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get mileage claim by ID
 *
 * A participant gets `created_by_user_id`, `created_by_user` and
 * `details.reviewed_by` as null.
 * A User gets `allowed_actions`, what they can do to the claim now.
 * @summary Get Mileage Claim
 */
export const getMileageClaimMileageClaimIdGet = (
  claimId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<MileageClaimRead>(
    { url: `/mileage/${claimId}`, method: "GET", signal },
    options
  );
};

export const getGetMileageClaimMileageClaimIdGetQueryKey = (
  claimId: string
) => {
  return [`/mileage/${claimId}`] as const;
};

export const getGetMileageClaimMileageClaimIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMileageClaimMileageClaimIdGetQueryKey(claimId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>
  > = ({ signal }) =>
    getMileageClaimMileageClaimIdGet(claimId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: claimId !== null && claimId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMileageClaimMileageClaimIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>
>;
export type GetMileageClaimMileageClaimIdGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetMileageClaimMileageClaimIdGet<
  TData = Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
          TError,
          Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMileageClaimMileageClaimIdGet<
  TData = Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
          TError,
          Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMileageClaimMileageClaimIdGet<
  TData = Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Mileage Claim
 */

export function useGetMileageClaimMileageClaimIdGet<
  TData = Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMileageClaimMileageClaimIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMileageClaimMileageClaimIdGetQueryOptions(
    claimId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Submit a mileage claim.
 *
 * A participant raises their own claim, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `body.participant_id`.
 *
 * Refused with 422 `PMT-05` when the participant's current Default Payment Account cannot receive mileage claims (for example a Stripe Stipend Card); another payment method must be chosen.
 *
 * A `unit` other than `km` or `mi` is refused with a 422 validation error on `body.unit`, before any claim or participant visit is created. The claim stores and returns the distance in the site's Travel Rate Unit.
 *
 * A `distance` of 0 or less is refused with a 422 validation error on `body.distance`, before any claim or participant visit is created.
 *
 * Refused with 422 `CLM-05` when the total comes to 0 once rounded down for the claim currency, and no claim or participant visit is created.
 * @summary Submit Mileage Claim
 */
export const submitMileageClaimMileagePost = (
  mileageClaimCreate: BodyType<MileageClaimCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<MileageClaimRead>(
    {
      url: `/mileage`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: mileageClaimCreate,
      signal,
    },
    options
  );
};

export const getSubmitMileageClaimMileagePostMutationKey = () =>
  ["submitMileageClaimMileagePost"] as const;

export const getSubmitMileageClaimMileagePostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitMileageClaimMileagePost>>,
    TError,
    SubmitMileageClaimMileagePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitMileageClaimMileagePost>>,
  TError,
  SubmitMileageClaimMileagePostMutationVariables,
  TContext
> => {
  const mutationKey = getSubmitMileageClaimMileagePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitMileageClaimMileagePost>>,
    SubmitMileageClaimMileagePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return submitMileageClaimMileagePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitMileageClaimMileagePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitMileageClaimMileagePost>>
>;
export type SubmitMileageClaimMileagePostMutationBody =
  BodyType<MileageClaimCreate>;
export type SubmitMileageClaimMileagePostMutationError =
  ErrorType<ErrorResponse>;
export interface SubmitMileageClaimMileagePostMutationVariables {
  data: BodyType<MileageClaimCreate>;
}

/**
 * @summary Submit Mileage Claim
 */
export const useSubmitMileageClaimMileagePost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitMileageClaimMileagePost>>,
      TError,
      SubmitMileageClaimMileagePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitMileageClaimMileagePost>>,
  TError,
  SubmitMileageClaimMileagePostMutationVariables,
  TContext
> => {
  return useMutation(
    getSubmitMileageClaimMileagePostMutationOptions(options),
    queryClient
  );
};
/**
 * Calculate mileage claim total before submission.
 *
 * A participant calculates their own claim, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `body.participant_id`.
 *
 * Refused with 422 `PMT-05` when the participant's current Default Payment Account cannot receive mileage claims (for example a Stripe Stipend Card); another payment method must be chosen.
 *
 * A `unit` other than `km` or `mi` is refused with a 422 validation error on `body.unit`. The result gives the distance in the site's Travel Rate Unit.
 *
 * A `distance` of 0 or less is refused with a 422 validation error on `body.distance`.
 *
 * Refused with 422 `CLM-05` when the total comes to 0 once rounded down for the claim currency.
 * @summary Calculate Mileage Claim
 */
export const calculateMileageClaimMileageCalculatePost = (
  mileageClaimCalculationCreate: BodyType<MileageClaimCalculationCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<MileageClaimCalculationRead>(
    {
      url: `/mileage/calculate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: mileageClaimCalculationCreate,
      signal,
    },
    options
  );
};

export const getCalculateMileageClaimMileageCalculatePostMutationKey = () =>
  ["calculateMileageClaimMileageCalculatePost"] as const;

export const getCalculateMileageClaimMileageCalculatePostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculateMileageClaimMileageCalculatePost>>,
    TError,
    CalculateMileageClaimMileageCalculatePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculateMileageClaimMileageCalculatePost>>,
  TError,
  CalculateMileageClaimMileageCalculatePostMutationVariables,
  TContext
> => {
  const mutationKey = getCalculateMileageClaimMileageCalculatePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculateMileageClaimMileageCalculatePost>>,
    CalculateMileageClaimMileageCalculatePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return calculateMileageClaimMileageCalculatePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculateMileageClaimMileageCalculatePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof calculateMileageClaimMileageCalculatePost>>
  >;
export type CalculateMileageClaimMileageCalculatePostMutationBody =
  BodyType<MileageClaimCalculationCreate>;
export type CalculateMileageClaimMileageCalculatePostMutationError =
  ErrorType<ErrorResponse>;
export interface CalculateMileageClaimMileageCalculatePostMutationVariables {
  data: BodyType<MileageClaimCalculationCreate>;
}

/**
 * @summary Calculate Mileage Claim
 */
export const useCalculateMileageClaimMileageCalculatePost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof calculateMileageClaimMileageCalculatePost>>,
      TError,
      CalculateMileageClaimMileageCalculatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof calculateMileageClaimMileageCalculatePost>>,
  TError,
  CalculateMileageClaimMileageCalculatePostMutationVariables,
  TContext
> => {
  return useMutation(
    getCalculateMileageClaimMileageCalculatePostMutationOptions(options),
    queryClient
  );
};
/**
 * Review (approve or reject) a participant mileage claim.
 *
 * Requires relevant permission.
 *
 * Approval is refused with 422 `PMT-05`, before any payout is created, when
 * the participant's current Default Payment Account cannot receive mileage
 * claims (for example a Stripe Stipend Card). PPS pays that account, so a
 * claim reimbursement must never be routed to it.
 *
 * Approving stores the Approved Amount that PASS pays in `approved_amount`.
 * It is the Claimed Amount in `amount` unless `approved_amount` is sent, which
 * makes an Amount Adjustment. The claim is then approved and paid at that lower
 * amount, and `amount` keeps the Claimed Amount. `external_notes` is required as
 * the reason for the participant. An amount at or above the Claimed Amount is
 * refused with 422 `CLM-04` before any payout is created. Rejecting leaves
 * `approved_amount` null. The mileage `details` stay as submitted.
 *
 * While Claim Peer Review is on, the User who raised the claim cannot approve
 * it, with or without an Amount Adjustment, and gets 400 `APR-02` before any
 * payout is created. They can still reject it.
 * @summary Review Mileage Claim
 */
export const reviewMileageClaimMileageMileageIdReviewPost = (
  mileageId: string,
  claimReviewRequest: BodyType<ClaimReviewRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<MileageClaimRead>(
    {
      url: `/mileage/${mileageId}/review`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: claimReviewRequest,
      signal,
    },
    options
  );
};

export const getReviewMileageClaimMileageMileageIdReviewPostMutationKey = () =>
  ["reviewMileageClaimMileageMileageIdReviewPost"] as const;

export const getReviewMileageClaimMileageMileageIdReviewPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewMileageClaimMileageMileageIdReviewPost>>,
    TError,
    ReviewMileageClaimMileageMileageIdReviewPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviewMileageClaimMileageMileageIdReviewPost>>,
  TError,
  ReviewMileageClaimMileageMileageIdReviewPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getReviewMileageClaimMileageMileageIdReviewPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviewMileageClaimMileageMileageIdReviewPost>>,
    ReviewMileageClaimMileageMileageIdReviewPostMutationVariables
  > = (props) => {
    const { mileageId, data } = props ?? {};

    return reviewMileageClaimMileageMileageIdReviewPost(
      mileageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewMileageClaimMileageMileageIdReviewPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reviewMileageClaimMileageMileageIdReviewPost>>
  >;
export type ReviewMileageClaimMileageMileageIdReviewPostMutationBody =
  BodyType<ClaimReviewRequest>;
export type ReviewMileageClaimMileageMileageIdReviewPostMutationError =
  ErrorType<ErrorResponse>;
export interface ReviewMileageClaimMileageMileageIdReviewPostMutationVariables {
  mileageId: string;
  data: BodyType<ClaimReviewRequest>;
}

/**
 * @summary Review Mileage Claim
 */
export const useReviewMileageClaimMileageMileageIdReviewPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reviewMileageClaimMileageMileageIdReviewPost>>,
      TError,
      ReviewMileageClaimMileageMileageIdReviewPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reviewMileageClaimMileageMileageIdReviewPost>>,
  TError,
  ReviewMileageClaimMileageMileageIdReviewPostMutationVariables,
  TContext
> => {
  return useMutation(
    getReviewMileageClaimMileageMileageIdReviewPostMutationOptions(options),
    queryClient
  );
};
/**
 * Cancel a pending mileage claim, so it won't be paid.
 *
 * A participant cancels a claim they raised. A User with Claims Update cancels a claim a User raised for a participant, whichever User raised it. A User cancelling a claim the participant raised, or a participant cancelling a claim a User raised, is a 403 `ATH-05` and the claim stays pending. A User without Claims Update is a 403 `ATH-05`. A claim the User can't see or in another tenant is a 404 `COM-02`.
 *
 * Refused with 409 `CLM-03` when the claim is no longer pending, whoever cancels it.
 * @summary Cancel Mileage Claim
 */
export const cancelMileageClaimMileageMileageClaimIdDelete = (
  mileageClaimId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/mileage/${mileageClaimId}`, method: "DELETE", signal },
    options
  );
};

export const getCancelMileageClaimMileageMileageClaimIdDeleteMutationKey = () =>
  ["cancelMileageClaimMileageMileageClaimIdDelete"] as const;

export const getCancelMileageClaimMileageMileageClaimIdDeleteMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMileageClaimMileageMileageClaimIdDelete>>,
    TError,
    CancelMileageClaimMileageMileageClaimIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMileageClaimMileageMileageClaimIdDelete>>,
  TError,
  CancelMileageClaimMileageMileageClaimIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey =
    getCancelMileageClaimMileageMileageClaimIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMileageClaimMileageMileageClaimIdDelete>>,
    CancelMileageClaimMileageMileageClaimIdDeleteMutationVariables
  > = (props) => {
    const { mileageClaimId } = props ?? {};

    return cancelMileageClaimMileageMileageClaimIdDelete(
      mileageClaimId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMileageClaimMileageMileageClaimIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof cancelMileageClaimMileageMileageClaimIdDelete>>
  >;

export type CancelMileageClaimMileageMileageClaimIdDeleteMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface CancelMileageClaimMileageMileageClaimIdDeleteMutationVariables {
  mileageClaimId: string;
}

/**
 * @summary Cancel Mileage Claim
 */
export const useCancelMileageClaimMileageMileageClaimIdDelete = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelMileageClaimMileageMileageClaimIdDelete>>,
      TError,
      CancelMileageClaimMileageMileageClaimIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cancelMileageClaimMileageMileageClaimIdDelete>>,
  TError,
  CancelMileageClaimMileageMileageClaimIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getCancelMileageClaimMileageMileageClaimIdDeleteMutationOptions(options),
    queryClient
  );
};
